import React from "react";
import { teamData } from "../data";
import TeamCard from "../components/Team/TeamCard";
import PartnersSection from "../components/Team/PartnersSection";

const Team = () => {
  return (
    <div className="text-center bg-[#fafafa] ">
      <div className="top pt-8 pb-4 lg:pb-8">
        <h3 className="mt-[50px] md:mt-[50px] mb-[20px] text-[30px] lg:text-[46px] font-bold text-black px-8 md:px-12 lg:px-36 text-center">
          Meet The Team
        </h3>
        <p className="text-[14px] lg:text-[18px] font-normal text-black px-8 md:px-12 lg:px-36 text-center">
          Leafwell Farm is on a mission to provide a community <br className="hidden lg:block" /> for those seeking a serene meaningful & nature oriented lifestyle.
        </p>
      </div>
      <div
        className="grid grid-cols-1 sm:grid-cols-2 gap-8 justify-center items-center mx-auto my-8 px-4 md:px-6"
      >
        {teamData.map((card, index) => (
          <div key={index} className="w-full lg:px-6">
            <TeamCard
              image={card.image}
              name={card.name}
              description={card.description}
              position={card.position}
            />
          </div>
        ))}
      </div>
      <PartnersSection />
    </div>
  );
};

export default Team;
